import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// CMS Service - Home page content
export const getHomeCms = async () => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.GET_CMS_HOME);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getHomeCms,
};


